<template>
	<div class="enter registration cover">
		<!-- Outer -->
		<div class="enter__outer">
			<!-- Enter Inner -->
			<div class="enter__inner">

				<form id="entry_form" class="enter-form registration__form" @submit.prevent="createUser">
					<p class="enter__text enter__text_pt">Информация используеться для записи на прием</p>

					<!-- Enter Label -->
					<label class="enter__label" for="last_name">Фамилия
						<input class="enter-text-field enter-text-field_margin_n" v-model="last_name" id="last_name">
					</label>
					<!-- Enter Label End -->

					<!-- Enter Label -->
					<label class="enter__label" for="first_name">Имя
						<input class="enter-text-field enter-text-field_margin_n" v-model="first_name" id="first_name">
					</label>
					<!-- Enter Label End -->

					<!-- Enter Label -->
					<label class="enter__label" for="middle_name">Отчество
						<input class="enter-text-field enter-text-field_margin_n" v-model="middle_name" id="middle_name">
					</label>
					<!-- Enter Label End -->

					<div class="enter__btn-wrap enter__btn-wrap_flex">
						<input class="enter-form__button enter-form__button_gender" :class="{'active_gb': sex == 'male'}" @click="selectSex('male')" type="button" value="Муж">

					<input class="enter-form__button enter-form__button_gender" :class="{'active_gb':sex == 'female'}" @click="selectSex('female')" type="button" value="Жен">
					</div>


					<label class="enter__label" for="birthday">Дата рождения
						<input class="enter-text-field" v-model="birthday" v-mask="'##-##-####'" id="birthday" placeholder="число-месяц-год">
					</label>

					<!-- Checkbox -->
					<div class="checkbox basic__checkbox">
						<label class="checkbox__label">
							<input class="checkbox__input" type="checkbox" value="adult" v-model="terms">
							<span class="checkbox__custom-input basic__checkbox-custom-input"></span>
							<span class="checkbox__text basic__checkbox-pad enter__checkbox-text">"Принять <router-link :to="{name: 'Agreement'}" class="checkbox__link" target="_blank">Пользовательское соглашение</router-link>"</span>
						</label>
					</div>
					<!-- Checkbox End -->

					<input class="enter-form__button" type="submit" value="Начать пользоваться">
					<p class="enter__text">Шаг 4 из 4</p>

				</form>

			</div>
			<!-- Enter Inner End -->
		</div>
		<!-- Outer End -->
	</div>
</template>

<script>
	import moment from 'moment'

	export default {
		name: "ThirdStep",
		computed: {
			phone() {
				return this.$storage.get('reg.phone')
			},
			password() {
				return this.$storage.get('reg.password')
			},
			rePassword() {
				return this.$storage.get('reg.rePassword')
			},
			code() {
				return this.$storage.get('reg.code')
			}
		},
		data() {
			return {
				first_name: "",
				middle_name: "",
				last_name: "",
				sex: 'male',
				birthday: "",
				terms: false
			}
		},
		methods: {
			createUser() {
				if (!this.first_name || !this.middle_name || !this.last_name || !this.birthday) {
					this.$event.toast('e', 'Заполните все поля, пожалуйста')
					return false
				}

				if (!this.terms) {
					this.$event.toast('e', 'Подтвердите лицензионное соглашение')
					return false
				}

				this.$api.post("auth/registration", {
					code: this.code,
					phone: this.phone,
					first_name: this.first_name,
					middle_name: this.middle_name,
					last_name: this.last_name,
					sex: this.sex,
					birthday: moment(this.birthday, 'DD-MM-YYYY').format('X'),
					password: this.password,
					password_confirmation: this.rePassword
				}).then(response => {
					this.$store.commit('auth/setUser', response);
					this.$storage.removeMore(['reg.phone', 'reg.password', 'reg.rePassword', 'reg.code']);
					if(localStorage.getItem('pageBeforeLogin')) {
						var linkToStart = localStorage.getItem('pageBeforeLogin')
						localStorage.removeItem('pageBeforeLogin')
						this.$router.push(linkToStart)
					} else {
						this.$router.push({
							name: 'Cabinet',
							params: {id: response._id}
						});
					}
				})
			},
			selectSex(sex) {
				this.sex = sex
			}
		}
	}
</script>
<style scoped>
	.active_gb {
		background-color: #0f2142;
	}
</style>



// WEBPACK FOOTER //
// Four.vue?38610a41